import styled from 'styled-components';

export const VerticalDivider = styled.div`
  border-right: 2px solid ${(props) => props.theme.colors.borderPrimary};
  width: 1px;
  height: 34px;
`;
